module.exports = __webpack_public_path__ + "img/wy.5e43f055.png";